export default "__VITE_ASSET__DJuYEuPt__"